import { useAtom } from '@reatom/npm-react'
import { useTranslation } from 'react-i18next'
import styled from 'styled-components'

import { referralInfoAtom } from '@root/entities/referral'
import { CountMax5DigitsFormatted } from '@root/shared/core/format/numeric-presets-components'
import { GroupExactIcon } from '@root/shared/ui-kit'

import { ReferralCard } from './referral-card-common'

type ReferralCodeCardProps = {
  onNavigateToReferrals: () => void
}

export const ReferralCardReferrals = (props: ReferralCodeCardProps) => {
  const { t } = useTranslation()
  const [referralInfo] = useAtom(referralInfoAtom)
  const totalReferrals = referralInfo?.referralsCount ?? 0

  return (
    <>
      <ReferralCard onClick={props.onNavigateToReferrals}>
        <ReferralCard.Header>
          <Icon icon={GroupExactIcon} />
          <ReferralCard.Title>
            {t('referral.referral_users')}
          </ReferralCard.Title>
        </ReferralCard.Header>
        <ReferralCard.Content>
          <Content>
            <Count data-has-data={totalReferrals > 0}>
              <CountMax5DigitsFormatted count={totalReferrals} />
            </Count>
            {t('referral.users-referred')}
          </Content>
        </ReferralCard.Content>
      </ReferralCard>
    </>
  )
}

const Icon = styled(ReferralCard.Icon)`
  color: var(--purple-9);
`

const Count = styled.span`
  color: var(--text-9);
  font-size: 18px;
  font-weight: 700;
  line-height: 20px; /* 111.111% */

  &[data-has-data='true'] {
    color: var(--text-12);
  }
`

const Content = styled.div`
  display: grid;
  grid-auto-flow: column;
  gap: 5px;
  align-items: baseline;
  justify-content: start;
`
